import type { ReactNode } from "react";
import { AtomIcon } from "./AtomIcon";

interface LogoProps {
  /** Optional trailing control rendered at the end of the logo row —
   *  .logo-area is already flex, so this just joins the row. Used by the
   *  sidebar header's collapse button (WR-W S1); backward compatible for
   *  every other call site that renders the bare logo. */
  trailing?: ReactNode;
}

export function Logo({ trailing }: LogoProps = {}) {
  return (
    <div className="logo-area">
      <div className="logo-icon">
        <AtomIcon size={28} />
      </div>
      <div>
        <div className="display" style={{ fontSize: "1.25rem", lineHeight: 1 }}>SOVEREIGN</div>
        <div className="logo-subtitle">MUSE</div>
      </div>
      {trailing}
    </div>
  );
}
